export default __webpack_public_path__ + "static/media/fingerprint1.5ccf4bd5.svg";